import {
  ChangeDetectorRef,
  Component,
  ElementRef,
  Inject,
  Input,
  OnChanges,
  SimpleChanges,
} from '@angular/core';
import feather from 'feather-icons';

@Component({
  selector: 'lib-icon',
  templateUrl: './icon.component.html',
  styleUrls: ['./icon.component.scss'],
  standalone: false,
})
export class IconComponent implements OnChanges {
  @Input() name!: string;
  @Input() size: 'x-small' | 'small' | 'medium' | 'large';
  @Input() interactive = false;

  constructor(
    @Inject(ElementRef) private elem: ElementRef,
    @Inject(ChangeDetectorRef) private changeDetector: ChangeDetectorRef,
  ) {}

  ngOnChanges(changes: SimpleChanges) {
    if (!feather) {
      return;
    }

    let svg = feather.icons[changes.name.currentValue].toSvg() || '';
    svg = svg.replace('width="24"', '');
    svg = svg.replace('height="24"', '');
    this.elem.nativeElement.innerHTML = svg;
    if (this.size) {
      this.elem.nativeElement.classList.add(`size-${this.size}`);
    }
    if (this.interactive) {
      this.elem.nativeElement.classList.add('interactive');
    }

    this.changeDetector.markForCheck();
  }
}
